<script>
  import { fly } from 'svelte/transition';
  import { Carousel, CarouselControl, CarouselItem } from '@sveltestrap/sveltestrap';

  /**
   * Index of the currently visible item.
   * @type {number}
   */
  export let activeIndex;

  /**
   * Array of items to be rendered in the carousel.
   * @type {any[]}
   */
  export let items;

  /**
   * Reference to the Svelte Carousel instance.
   * @type {CarouselRef}
   * @default null
   */
  export let ref = null;

  /**
   * Boolean flag to determine whether carousel navigation controls (arrows) should be displayed or not.
   * @type {boolean}
   * @default true
   */
  export let showControls = true;

  const TRANSITION_DURATION_MS = 500;

  let carouselMovedRight = true;
  let delta = 0;
  let previousIndex = 0;

  const flyIn = (node) => {
    return fly(node, {
      x: carouselMovedRight ? 450 : -450,
      duration: TRANSITION_DURATION_MS
    });
  };

  const flyOut = (node) => {
    return fly(node, {
      x: carouselMovedRight ? -450 : 450,
      duration: TRANSITION_DURATION_MS
    });
  };

  $: {
    delta = activeIndex - previousIndex;
    carouselMovedRight = delta === 1 || delta === -(items.length - 1);
    previousIndex = activeIndex;
  }
</script>

<Carousel bind:activeIndex bind:this={ref} {...$$restProps} {items}>
  <div class="carousel-inner">
    {#each items as item, index}
      {#if activeIndex === index}
        <div in:flyIn out:flyOut>
          <CarouselItem itemIndex={index} bind:activeIndex>
            <slot {index} {item} />
          </CarouselItem>
        </div>
      {/if}
    {/each}
  </div>

  {#if showControls}
    <CarouselControl direction="prev" {items} bind:activeIndex data-testid="left-arrow" />
    <CarouselControl direction="next" {items} bind:activeIndex data-testid="right-arrow" />
  {/if}
</Carousel>

<style lang="scss" src="./carousel.scss"></style>
